import { TransactionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/transaction/paginated/transaction.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { TransactionListTokenTypeCell } from '@app/feature/transaction/transaction-list/transaction-list-token-type.cell';
import { TransactionListTokenTypeHeader } from '@app/feature/transaction/transaction-list/transaction-list-token-type.header';

export const ChargePointChannelTransactionListTokenTypeColumn: IdentifiedColumnDef<
  TransactionModel,
  NonNullable<TransactionModel['token']>['type'] | undefined
> = {
  id: 'tokenType',
  enableSorting: false,
  header: TransactionListTokenTypeHeader,
  cell: TransactionListTokenTypeCell,
};
